/**
 * 销售顾问模拟数据
 * http://mockjs.com/
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 销售指标统计 - 销售顾问
Mock.mock(/sale_report\/sale_quota_analysis/, 'get' + mockSwitch, {
  'code': 0,
  'data': [
    {
      'booked': 11,
      'deal': 11,
      'new_reception': 1,
      'phone': 11,
      'reception': 10,
      'review': 11,
      'sale': '销售-A'
    },
    {
      'booked': 11,
      'deal': 11,
      'new_reception': 11,
      'phone': 11,
      'reception': 10,
      'review': 11,
      'sale': '销售-B'
    },
    {
      'booked': 11,
      'deal': 11,
      'new_reception': 11,
      'phone': 11,
      'reception': 11,
      'review': 11,
      'sale': '销售-C'
    },
    {
      'booked': 11,
      'deal': 11,
      'new_reception': 11,
      'phone': 11,
      'reception': 11,
      'review': 11,
      'sale': '销售-D'
    },
    {
      'booked': 11,
      'deal': 11,
      'new_reception': 11,
      'phone': 11,
      'reception': 11,
      'review': 11,
      'sale': '合计'
    }
  ],
  'message': 'ok'
})

// 所有的销售顾问
Mock.mock(/sale_report\/sales/, 'get' + mockSwitch, {
  'code': 0,
  'data': [
    {
      'id': 1,
      'name': '张三'
    }, {
      'id': 2,
      'name': '张三'
    }, {
      'id': 3,
      'name': '张三'
    }, {
      'id': 4,
      'name': '张三'
    }, {
      'id': 5,
      'name': '张三'
    }, {
      'id': 6,
      'name': '张三'
    }
  ],
  'message': 'ok'
})

// 销售顾问营销漏斗分析 - 销售顾问
Mock.mock(/sale_report\/sale_funnel_statistical_analysis/, 'get' + mockSwitch, {
  'code': 0,
  'data': [
    {
      'arrived': '5',
      'deal': 11,
      'deal_rate': 0.01,
      'review': 11,
      'arrived_type': '首次到店',
      'first_type': 'FU'
    }, {
      'arrived': '5',
      'deal': 11,
      'deal_rate': 0.01,
      'review': 11,
      'arrived_type': '首次到店',
      'first_type': 'PU'
    }, {
      'arrived': '5',
      'deal': 11,
      'deal_rate': 0.01,
      'review': 11,
      'arrived_type': '首次到店',
      'first_type': 'NET'
    }, {
      'arrived': '5',
      'deal': 11,
      'deal_rate': 0.01,
      'review': 11,
      'arrived_type': '二次到店',
      'first_type': ''
    }, {
      'arrived': '5',
      'deal': 11,
      'deal_rate': 0.01,
      'review': 11,
      'arrived_type': '合计',
      'first_type': ''
    }
  ],
  'message': 'ok'
})
